export default __webpack_public_path__ + "static/media/wrong_ans.a8b439f7.svg";